const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/modules/CIS4m/actions.ts';
import { KeyValuePair } from '../../defs/generalDefs';
import { CIS4mConfig, SaveStatus } from './types';
import { validateForm } from './utils/form';

export const START_CIS4M = 'START_CIS4M';
export const REMOVE_CIS4M = 'REMOVE_CIS4M';
export const SET_CIS4M_DATA_OBJECT = 'SET_CIS4M_DATA_OBJECT';
export const SET_DEFAULT_IN_CIS4M_DATA_OBJECT = 'SET_DEFAULT_IN_CIS4M_DATA_OBJECT';
export const SET_IN_CIS4M_DATA_OBJECT = 'SET_IN_CIS4M_DATA_OBJECT';
export const REMOVE_FROM_CIS4M_DATA_OBJECT = 'REMOVE_FROM_CIS4M_DATA_OBJECT';
export const SAVE_CIS4M = 'SAVE_CIS4M';
export const SAVE_CIS4M_SUCCESS = 'SAVE_CIS4M_SUCCESS';
export const SAVE_CIS4M_FAILURE = 'SAVE_CIS4M_FAILURE';

export const actionTypes = {
    setSaveStatus: 'SET_MOBILE_FORM_SAVE_STATUS',
};

export const actionStartCIS4m = function (config: CIS4mConfig[]) {
    return {
        type: START_CIS4M,
        payload: {
            config,
        },
    };
};

export type StartCIS4mAction = ReturnType<typeof actionStartCIS4m>;

export const actionSetDefaultInCIS4mDataObject = function (formId: string, path: string, value: any) {
    return {
        type: SET_DEFAULT_IN_CIS4M_DATA_OBJECT,
        payload: {
            formId,
            path,
            value,
        },
    };
};

export type ActionSetDefaultInCIS4mDataObject = ReturnType<typeof actionSetDefaultInCIS4mDataObject>;

export const actionSetInCIS4mDataObject = function (formId: string, path: string, value: any) {
    return {
        type: SET_IN_CIS4M_DATA_OBJECT,
        payload: {
            formId,
            path,
            value,
        },
    };
};

export type ActionSetInCIS4mDataObject = ReturnType<typeof actionSetInCIS4mDataObject>;

export const actionSetCIS4mDataObject = function (formId: string, formData: KeyValuePair) {
    return {
        type: SET_CIS4M_DATA_OBJECT,
        payload: {
            formId,
            formData,
        },
    };
};

export type ActionSetCIS4mDataObject = ReturnType<typeof actionSetCIS4mDataObject>;

export const actionRemoveFromCIS4mDataObject = function (formId: string, path: string) {
    return {
        type: REMOVE_FROM_CIS4M_DATA_OBJECT,
        payload: {
            formId,
            path,
        },
    };
};

export type ActionRemoveFromCIS4mDataObject = ReturnType<typeof actionRemoveFromCIS4mDataObject>;

export const actionRemoveCIS4m = function (formId: string) {
    return {
        type: REMOVE_CIS4M,
        payload: {
            formId,
        },
    };
};

export type ActionRemoveCIS4m = ReturnType<typeof actionRemoveCIS4m>;

// FIXME don't pass callbacks to Redux actions, or use a different naming, e.g.: callOnSaveAndGetSaveAction()
export const actionSaveCIS4m = (formId: string, formRefValue: any, onBeforeSave?: () => void) => {
    if (formRefValue) {
        formRefValue.onSave();
        onBeforeSave?.();
    } else {
        throw Error('Cannot save form because formRef does not have the "current" property.');
    }

    return {
        type: SAVE_CIS4M,
        payload: { formId },
    };
};

export type ActionSaveCIS4m = ReturnType<typeof actionSaveCIS4m>;

// This action exists because actionValidateAndSaveCIS4m needs to return something when the form does not validate,
// and isn't going to try to save.... FIXME if you don't need it, remove it
const actionCIS4mInvalid = () => ({
    type: 'CIS4M_INVALID',
});

// FIXME this isn't a pure Redux action, so it should be called validateFormAndGetSaveAction()
export const actionValidateAndSaveCIS4m = (
    formId: string,
    formRefValue: any,
    onValidate?: (success: boolean) => void,
    onBeforeSave?: () => void
) => {
    const success = validateForm(formRefValue);
    onValidate?.(success);
    if (success) {
        return actionSaveCIS4m(formId, formRefValue, onBeforeSave);
    }
    return actionCIS4mInvalid();
};

export type ActionValidateAndSaveCIS4m = ReturnType<typeof actionValidateAndSaveCIS4m>;

export const actionSaveCIS4mSuccess = function (formId: string) {
    return {
        type: SAVE_CIS4M_SUCCESS,
        payload: { formId },
    };
};

export type ActionSaveCIS4mSuccess = ReturnType<typeof actionSaveCIS4mSuccess>;

export const actionSaveCIS4mFailure = function (formId: string) {
    return {
        type: SAVE_CIS4M_FAILURE,
        payload: { formId },
    };
};

export type ActionSaveCIS4mFailure = ReturnType<typeof actionSaveCIS4mFailure>;

export interface SetSaveStatusAction {
    type: string;
    payload: {
        saveStatus: string;
    };
}

export const actionSetSaveStatus = function (saveStatus: SaveStatus): SetSaveStatusAction {
    return {
        type: actionTypes.setSaveStatus,
        payload: {
            saveStatus: saveStatus,
        },
    };
};
